"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cccisdModal = _interopRequireDefault(require("cccisd-modal"));
var _cccisdTooltip = _interopRequireDefault(require("cccisd-tooltip"));
var _IconBase = _interopRequireDefault(require("cccisd-icons/dist/IconBase.js"));
var _cccisdGraphqlTable = _interopRequireDefault(require("cccisd-graphql-table"));
var _reportTemplates = _interopRequireDefault(require("../reportTemplates.js"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var appDefs = window.cccisd.appDefs;
var _default = exports["default"] = function _default(props) {
  var text = props.text,
    tooltip = props.tooltip;
  var content = {};
  if (props.content.type === 'report') {
    if (appDefs.reports.list) {
      content = appDefs.reports.list.find(function (t) {
        return t.id === props.content.handle;
      });
    }
  }
  if (props.content.type === 'table') {
    if (appDefs.tables.list) {
      content = appDefs.tables.list.find(function (t) {
        return t.id === props.content.handle;
      });
    }
  }
  var _renderTile = function _renderTile() {
    var icon = {
      id: 'site',
      paths: ['M1024 590.444l-512-397.426-512 397.428v-162.038l512-397.426 512 397.428zM896 576v384h-256v-256h-256v256h-256v-384l384-288z'],
      backgroundColor: '#f2d56e',
      color: '#fff',
      viewBox: '0 0 1024 1024'
    };
    if (props.icon !== 'url') {
      icon = appDefs.reportCenters.icons.find(function (i) {
        return i.id === props.icon;
      });
    }
    var tile = /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].wrapper
    }, props.icon === 'url' ? /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].imageIcon,
      style: {
        backgroundImage: "url(".concat(props.iconUrl, ")")
      }
    }) : /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].iconBox,
      style: icon.backgroundColor ? {
        backgroundColor: icon.backgroundColor
      } : {
        backgroundColor: icon.color
      }
    }, /*#__PURE__*/_react["default"].createElement("div", {
      style: icon.backgroundColor ? {
        color: icon.color,
        fontSize: '1.5em'
      } : {
        color: '#fff',
        fontSize: '1.5em'
      }
    }, /*#__PURE__*/_react["default"].createElement(_IconBase["default"], {
      viewBox: icon.viewBox,
      key: icon.id
    }, /*#__PURE__*/_react["default"].createElement("g", null, icon.paths.map(function (p, index) {
      return /*#__PURE__*/_react["default"].createElement("path", {
        key: index,
        d: p
      });
    }))))), /*#__PURE__*/_react["default"].createElement("div", {
      className: _style["default"].textBox
    }, text));
    if (tooltip && tooltip.length > 0) {
      return /*#__PURE__*/_react["default"].createElement(_cccisdTooltip["default"], {
        title: tooltip
      }, tile);
    }
    return tile;
  };
  var _renderReportPlayer = function _renderReportPlayer() {
    var tileReportHandle = props.content.handle;
    var reportSettings = props.reports.list.find(function (report) {
      return report.id === tileReportHandle;
    });
    var currentReportTemplate;
    if (reportSettings) {
      currentReportTemplate = _reportTemplates["default"].find(function (item) {
        return item.handle === reportSettings.reportTemplateHandle;
      });
    }
    if (!currentReportTemplate) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, "Couldn't find this Report.");
    }
    var Player = currentReportTemplate.player;
    return /*#__PURE__*/_react["default"].createElement(Player, {
      isPreview: true,
      settings: reportSettings.reportTemplateSettings,
      filterProps: currentReportTemplate.filterProps ? currentReportTemplate.filterProps : {},
      widgetProps: currentReportTemplate.widgetProps ? currentReportTemplate.widgetProps : {}
    });
  };
  return /*#__PURE__*/_react["default"].createElement("div", {
    style: {
      margin: '1em 1em 0 0'
    }
  }, /*#__PURE__*/_react["default"].createElement(_cccisdModal["default"], {
    title: text,
    size: "large",
    trigger: _renderTile()
  }, /*#__PURE__*/_react["default"].createElement("div", null, props.content.type === 'table' ? /*#__PURE__*/_react["default"].createElement(_cccisdGraphqlTable["default"], content.table) : /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, _renderReportPlayer()))));
};